import { useEffect } from 'react';

import { AsyncThunkAction } from '@reduxjs/toolkit';
import { useRouter } from 'next/router';

import { TLoanSortParams } from '@/redux/loans/model';

import { useAppDispatch } from './redux';

export const useSortRequest = (dispatchFn: (params: TLoanSortParams) => AsyncThunkAction<any, any, any> | null, deps: any[]) => {
  const {
    query: { sort, dir, searchTerm },
  } = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params: TLoanSortParams = {};

    if (typeof sort === 'string' && (dir === 'ASC' || dir === 'DESC')) {
      params.sort = sort;
      params.dir = dir;
    }
    if (searchTerm) {
      params.searchTerm = searchTerm;
    }
    const dispatcher = dispatchFn(params);

    if (!dispatcher) return;

    dispatch(dispatcher);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, sort, dir, searchTerm, ...deps]);
};
